import React from 'react';
import { SideNavbar } from '../navbar/sideNavbar';

export const MainLayout = ({ children }) => {
    return (
        <div className="d-flex">
            <SideNavbar />
            <div className="flex-grow-1 p-3" style={{ overflowY: 'auto', height: '100vh' }}>
                {children}
            </div>
        </div>
    );
};
